import constant from "../constant";
import {getStore} from "../api/storeAccessor";
import {getRouter} from "../router/routerAccessor";


function setResponseData(commit, response, update_timeout_timestamp_only=false) {


    let data = response.data;
    if (data.token != null) {
        // set if token is rotated
        commit('Auth/SET_TOKEN', data.token, {root: true});
    }
    //store.dispatch('Test/setGroupType', payload.group_type);
    commit('Test/SET_TEST_STATE', {test_state: data['state'], iframe_mode: getStore().state.iframe_mode}, {root: true});

    if (data['settings'] != null) {
        //set page settings
        commit('Test/SET_SETTINGS', data['settings'], {root: true});
    }

    if (data['data'] != null) {
        //set page data
        if (data['data']['user']) {
            commit('User/SET_USER_INFO', data['data']['user'], {root: true});
        }
        if (data['data']['test'] && data['data']['test']['photo_state']) {
            commit('Monitoring/SET_PHOTO_STATE', data['data']['test']['photo_state'], { root: true });
        }
        if(update_timeout_timestamp_only){
            commit('Test/SET_EXPIRED_TIMESTAMP', data['data'], {root: true});
        }else {

            commit('Test/SET_DATA', data['data'], {root: true});
        }
    }

    if (data['language'] != null && data['language'].length != 0) {
        commit('Language/SET_LANGUAGE', data['language'], {root: true});
    }
}


/***
 * Handle no internet error
 *
 *
 */
function handleNoInternetError(error, display_modal = false, test_page=false) {

    if (test_page || error.message == constant.ERROR_NO_INTERNET) {
        let error = {
            'error_code': constant.ERROR_NO_INTERNET,
            'type': constant.ERROR_NO_INTERNET,
            'error_level': 'error',
            'message': constant.ERROR_MESSAGES[constant.ERROR_NO_INTERNET]
        }
        getStore().dispatch('Error/setMessage', {'error': error}, {root: true});
        if (display_modal) {
            getStore().dispatch('Error/openModal');
        }
        // throw error;
    }
}

function __displayErrorPage(){
    /*
        We need to set little bit of delay (200ms) to close complete test modal in test page before showing global error page
        - Error handling => test.vue unmounted => test modal close => then display global error page.
    */

    setTimeout(()=>{
        getStore().dispatch('Error/displayFullPageError')
    },200)

}


/**
 * This function handles errors for globally handl
 * Decide
 * @param error
 * @param app_variables
 * @param test_page
 */
/**
 * This function handles global errors such as System error, network error, and so on, which the app requires
 * to handle globally (Display errors in the global error page).
 * If the app requires individual error handling in the page with error modal, this function doesn't handle
 * those errors. Instead, the function re-throws the error again, so the Vue page can re-handle the error properly
 *
 * @param error
 * @param app_variables
 * @param test_page
 * @param ignore_status_code: if http_status code is provided, rethrow error to ignore
 */
function handleError(error, app_variables=null, test_page=false, ignore_status_code=[]) {


    /// Check network error
    if(!error.response && error.request){ // network error
        handleNoInternetError(null, true, test_page);
    }

    if(ignore_status_code.includes(error.response.status)){
        getStore().dispatch('Auth/setTokenFromErrorResponse', error, {root: true})
        throw error;
    }

    // check when CloudFlare challenge status
    if(error.response.headers.hasOwnProperty('cf-mitigated') && error.response.headers['cf-mitigated'] === 'challenge'){

        //Unregister beforeunload event from the application
        if(app_variables !== null) {
            window.removeEventListener('beforeunload', app_variables.$popupUnLoadEvent);
        }

        // reload the browser
        window.location.reload();

    } else {

        let quiz_id = new URL(location.href).searchParams.get('quiz') ?? '';


        // This error only happening when hit test/init() end point.
        if (error.response.data.hasOwnProperty('test_setting') && error.response.data.test_setting != null) {
            let data = [];
            data['test'] = error.response.data.test_setting;
            getStore().dispatch('Test/setTestSettingFromErrorPage', data);
        }

        // check and assign language
        if (error.response.data.language != null) {
            getStore().dispatch('Language/setLanguage', error.response.data.language);
        }

        // check and assign theme
        if (error.response.data.theme != null) {
            getStore().dispatch('Test/setTheme', error.response.data.theme);
        }



        if (error.response.status == 500) { // System error

            // set error message for Error page
            getStore().dispatch('Error/setMessageFromAPI', error, {root: true});
            getStore().dispatch('Test/setState', 'error')
            __displayErrorPage()


            // redirect to error page
            // router.replace({name: 'Error', query: {quiz: quiz_id}});

        } else { // Other errors

            let path_name = window.location.pathname;
            switch (error.response.data.error_code) {
                case constant.ERROR_OFF_LINE_MODE:
                    /*
                       We need to set little bit of delay (200ms) to close complete test modal in test page before showing global error page
                       - Error handling => test.vue unmounted => test modal close => then display global error page.
                    */
                    setTimeout(()=>{
                        getStore().dispatch('Error/setMessageFromAPI', error, {root: true});
                        getStore().dispatch('setOfflineStatus', constant.STATUS_OFF_LINE);
                    }, 200)

                    break;
                case constant.ERROR_NO_CREDIT_FREE_USER:
                case constant.ERROR_NO_CREDIT_PAID_USER:
                case constant.ERROR_AUTH_TOKEN_EXPIRED: // auth token expired
                case constant.ERROR_ACCESS_TOKEN_EXPIRED: //access token expired
                case constant.ERROR_MULTIPLE_BROWSER_DETECTED: // multiple browser detected
                case constant.ERROR_NO_CM_USER_ID:
                case constant.ERROR_IP_NOT_ALLOWED:
                case constant.ERROR_INACTIVE_ACCOUNT:
                case constant.ERROR_TEST_UNAVAILABLE:
                case constant.ERROR_NO_QUESTIONS_IN_TEST:
                case constant.ERROR_INVALID_CLIENT_REFERER:
                case constant.ERROR_INVALID_QUIZ_ID:
                case constant.ERROR_INVALID_PREVIEW_TEST:
                case constant.ERROR_TEST_NO_LONGER_AVAILABLE:
                case constant.ERROR_BAD_REQUEST:

                    // set error message for Error page
                    getStore().dispatch('Error/setMessageFromAPI', error, {root: true});
                    getStore().dispatch('Test/setState', 'error')
                    __displayErrorPage()
                    break;
                case constant.ERROR_TEST_LIMIT_REACHED:

                    if (path_name.includes('/access-code/') === false) {
                        getStore().dispatch('Error/setMessageFromAPI', error, {root: true});
                        getStore().dispatch('Test/setState', 'error')
                        __displayErrorPage()
                        break;
                    } else {
                        getStore().dispatch('Auth/setTokenFromErrorResponse', error, {root: true})
                        throw error;
                        break;
                    }
                case constant.ERROR_INVALID_ACCESS_CODE:
                case constant.ERROR_TEST_LIMIT_REACHED:
                case constant.ERROR_ACCESS_CODE_PASSWORD_BEFORE_START_TEST:

                    let field = error.response.data.field ?? null
                    if (field == 'cm_user_id') {

                        // cm_user_id is no longer available.
                        getStore().dispatch('Error/setMessageFromAPI', error, {root: true});
                        getStore().dispatch('Test/setState', constant.STATUS_ACCESS_CODE)
                        __displayErrorPage()
                        break;
                    } else {

                        // access code is no longer available.
                        if (path_name.includes('/access-code/') === false) {
                            getStore().dispatch('Error/setMessageFromAPI', error, {root: true});
                            getStore().dispatch('Test/setState', constant.STATUS_ACCESS_CODE)
                            getRouter().replace({name: 'AccessCode', query: {quiz: quiz_id}});
                            break;
                        } else {
                            getStore().dispatch('Auth/setTokenFromErrorResponse', error, {root: true})
                            throw error;
                            break;
                        }
                    }
                case constant.ERROR_TOO_MAY_SIM_USERS:

                    getStore().dispatch('Error/setMessageFromAPI', error, {root: true});
                    getStore().dispatch('setOfflineStatus', constant.STATUS_ONLINE_WAITING_SIM_USER_SLOT);
                    getStore().dispatch('setReachSimUserLimit', true);
                    break;
                default:
                    /*
                       For the most of errors need to handled in each page. This code ensure set the access token from
                       the error object and rethrow it. So, the page can handle the error seperately.
                     */
                    getStore().dispatch('Auth/setTokenFromErrorResponse', error, {root: true})
                    throw error;
            }

        }
    }
}

export default {setResponseData, handleError, handleNoInternetError};